/* eslint-disable */
/* tslint:disable */
/* Do not edit - generated by swagger-typescript-api */

import {
  Condition,
  ErrorResponse,
  ProductListResponseCollectionResponse,
  ProductResponseCollectionResponse,
  ProductResponseEntityListVersionItemsResponse,
  Sorting,
} from './data-contracts';
import { HttpClient, RequestParams } from './http-client';
export class ProductLists<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;
  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }
  /**
   * No description
   *
   * @tags ProductLists
   * @name ProductListsList
   * @request GET:/ProductLists
   * @response `200` `ProductListResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  productListsList = (
    query?: {
      /** @format int32 */
      skip?: number;
      /** @format int32 */
      top?: number;
      inlineCount?: boolean;
      search?: string;
      sortings?: Sorting[];
      conditions?: Condition[];
    },
    params: RequestParams = {},
  ) =>
    this.http.request<ProductListResponseCollectionResponse, ErrorResponse>({
      path: `/ProductLists`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags ProductLists
   * @name GetProducts
   * @request GET:/ProductLists/{id}/Products
   * @response `200` `ProductResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getProducts = (
    id: number,
    query?: {
      /** @format int32 */
      skip?: number;
      /** @format int32 */
      top?: number;
      inlineCount?: boolean;
      search?: string;
      sortings?: Sorting[];
      conditions?: Condition[];
    },
    params: RequestParams = {},
  ) =>
    this.http.request<ProductResponseCollectionResponse, ErrorResponse>({
      path: `/ProductLists/${id}/Products`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags ProductLists
   * @name GetProductsForVersion
   * @request GET:/ProductLists/{id}/Versions/{versionId}/Products
   * @response `200` `ProductResponseEntityListVersionItemsResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getProductsForVersion = (
    id: number,
    versionId: number,
    query?: {
      /** @format int32 */
      skip?: number;
      /** @format int32 */
      top?: number;
      inlineCount?: boolean;
      search?: string;
      sortings?: Sorting[];
      conditions?: Condition[];
    },
    params: RequestParams = {},
  ) =>
    this.http.request<ProductResponseEntityListVersionItemsResponse, ErrorResponse>({
      path: `/ProductLists/${id}/Versions/${versionId}/Products`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
}
